import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Cookies from "js-cookie";
import "./Leave_A_Comment.css";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateComment,
  resetCommentState,
} from "../../../features/admin/comments/Slice";
import { useForm } from "react-hook-form";
import Success_Modal from "../../success-modal/Success_Modal";

const Leave_A_Comment = () => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);

      const res = await dispatch(CreateComment(data)).unwrap();

      if (res?.success) {
        setShowModal(true);
        reset();

        if (data.saveInfo) {
          Cookies.set("commenter_name", data.name, { expires: 30 });
          Cookies.set("commenter_email", data.email, { expires: 30 });
        } else {
          Cookies.remove("commenter_name");
          Cookies.remove("commenter_email");
        }

        setTimeout(() => {
          setShowModal(false);
          dispatch(resetCommentState());
        }, 2000);
      }
    } catch (err) {
      console.error("Comment submission error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    dispatch(resetCommentState());
  }, [dispatch]);

  const closeSuccessModal = () => {
    setShowModal(false);
    dispatch(resetCommentState());
  };

  useEffect(() => {
    const savedName = Cookies.get("commenter_name");
    const savedEmail = Cookies.get("commenter_email");

    if (savedName || savedEmail) {
      reset({
        name: savedName || "",
        email: savedEmail || "",
      });
    }

    dispatch(resetCommentState());
  }, [reset, dispatch]);

  return (
    <section className="Leave_A_Comment">
      <div className="container">
        <h5 className="Leave_A_Comment_title">
          Leave a <span>Comment</span>{" "}
        </h5>

        <div className="comment_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* Comment */}
            <Form.Group className="mb-4">
              <Form.Label>
                Comment<span className="required">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Comment Here"
                {...register("comment", {
                  required: "Comment is required",
                  minLength: {
                    value: 5,
                    message: "Comment must be at least 5 characters",
                  },
                  maxLength: {
                    value: 400,
                    message: "Comment must beyond 400 characters",
                  },
                })}
              />
              {errors.comment && (
                <small className="text-danger">{errors.comment.message}</small>
              )}
            </Form.Group>

            <div className="row">
              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Name<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("name", {
                      required: "Name is required",
                      minLength: {
                        value: 3,
                        message: "Name must be at least 3 characters",
                      },
                      maxLength: {
                        value:50,
                        message: "Name must be beyond 50 Characters",
                      },
                      pattern: {
                        value: /^[A-Za-z]+(\s[A-Za-z]+)*$/,
                        message:
                          "Name should contain only letters and single spaces",
                      },
                    })}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = value;

                      register("name").onChange(e);
                    }}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-6 col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Email<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    // placeholder="Enter your mail id"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?:[A-Za-z]{2,})$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-4">
              <Form.Check
                type="checkbox"
                label="Save my name, email, and website in this browser for the next time I comment."
                {...register("saveInfo")}
              />
            </Form.Group>

            <button
              className="submit_btn"
              type="submit"
              disabled={isSubmitting}
            >
              <p className="submit">
                {isSubmitting ? "Submitting..." : "Submit Comment"}
              </p>
            </button>
          </Form>
        </div>
      </div>

      <Success_Modal
        text_msg="Comment Submitted Successfully"
        show={showModal}
        handleClose={closeSuccessModal}
      />
    </section>
  );
};

export default Leave_A_Comment;
